export default {
  xs: 480,
  sm: 640,
  ipad: 768,
  tablet: 900,
  md: 1024,
  lg: 1280,
  xl: 1440,
  isTablet() {
    return window.matchMedia(`(min-width: ${this.tablet}px)`).matches;
  },
  isMd() {
    return window.matchMedia(`(min-width: ${this.md}px)`).matches;
  },
  isLg() {
    return window.matchMedia(`(min-width: ${this.lg}px)`).matches;
  },
  addBreakpointListenerTablet(callback) {
    return window
      .matchMedia(`(min-width: ${this.tablet}px)`)
      .addListener(callback);
  },
  addBreakpointListenerMd(callback) {
    return window.matchMedia(`(min-width: ${this.md}px)`).addListener(callback);
  },
  addBreakpointListenerLg(callback) {
    return window.matchMedia(`(min-width: ${this.lg}px)`).addListener(callback);
  }
};
